var mlrDevConfig = {
  production: false,
  appName: 'mlr',
  baseURL: 'http://localhost:8086/',
  media: "https://media.mirasee/",
  api: "https://api.mirasee/v2/mlr/",
  apiv3: "http://localhost:8080/api/v3/",
  cartUrl: "https://api.ultracart.com/"
};


var mlrProdConfig = {
  production: true,
  appName: 'mlr',
  baseURL: 'https://margaretlynchraniere.com/chakra/',
  media: "https://media.mirasee.com/",
  api: "https://api.mirasee.com/v2/",
  apiv3: "https://api.mirasee.com/v3/",
  cartUrl: "https://api.ultracart.com/"
};

if (process.env.NODE_ENV == 'development')
  var mlrConfig = mlrDevConfig;
else
  mlrConfig = mlrProdConfig;

export default mlrConfig;
